import styled from 'styled-components';
import { Flex } from './Flex';
import { ZINDEX } from 'shared/constants';

export const Card = styled(Flex)`
  position: absolute;
  z-index: ${ZINDEX.CARD};
  background-color: white;
  padding: 4px 8px;
  border-radius: 8px;
  margin-top: 16px;
  box-shadow: 0 0 10px #000;

  h2 {
    margin: 0;
    margin-bottom: 8px;
    font-size: 1.2em;
  }
  h3 {
    margin: 0;
    font-size: 1.1em;
  }
`;
